module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-72x729917306ec2981dfb70e1be8ebf54dd3d.png";